import {
  Component,
  OnInit,
  OnDestroy,
  Inject,
  Input,
  TemplateRef,
  QueryList,
  ViewChildren,
  ViewChild
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ParcelhistoryService } from '../../../@core/services/parcelhistory.service';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { StopService } from '../../../@core/services/stop.service';
import {
  MatDatepickerInputEvent,
  MatSort,
  MatSpinner,
  Sort
} from '@angular/material';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { RouteStatus } from '../../../@core/models/dto-routestatus';
import { SectorCompress, Stop } from '../../../@core/models/live-route';
import { SectorService } from '../../../@core/services/sector.service';
import { LiveRouteType } from '../../../@core/models/live-route-type';
import { AddExceptionDialogComponent } from '..';
import { ParcelHistoryDialogComponent } from '../parcel-history-dialog/parcel-history-dialog.component';

@Component({
  selector: 'ngx-non-completed-dialog',
  templateUrl: './non-completed-dialog.component.html',
  styleUrls: ['./non-completed-dialog.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0'})),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ]),
  ],
})
export class NonCompletedDialogComponent implements OnInit, OnDestroy {
  sectorID: number;
  searchDate: string;
  selectedSectorId: number;
  selectedStops: Stop[];
  dayDate: Date;
  @Input() tpl: TemplateRef<any>;
  @ViewChildren('matCheckbox') private matCheckboxes: QueryList<any>;
  @ViewChildren('spinner') private matSpinner: MatSpinner;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  public displayedColumns: string[] = [
    'IsSelected',
    'StatusIcon',
    'EXP_DATE',
    'Route_ID',
    'TotalParcel',
    'CustomerName',
    'Lr_Name',
    'Address.Address1',
    'Address.City',
    'Consol_ID'
  ];

  get liverouteType() {
    return LiveRouteType;
  }

  constructor(
    public dialogRef: MatDialogRef<NonCompletedDialogComponent>,
    public _parcelhistoryService: ParcelhistoryService,
    public translateService: TranslateService,
    public authenticationService: AuthenticationService,
    public stopService: StopService,
    public toastservice: ToastrService,
    public _sectorService: SectorService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    let calendardate = new Date();
    this.selectedStops = [];
    this.dayDate = calendardate;
  }
  ngOnDestroy(): void {}

  public addEvent(event: MatDatepickerInputEvent<Date>) {
    this.dayDate = event.value;
  }

  public setSelectedSectorId(sectorId: number) {
    this.selectedSectorId = sectorId;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.stopService.nonCompletedStops != null)
      return (
        this.selectedStops.length ==
        this.stopService.getNonCompletedStops.StopCount
      );
    else return false;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle($event) {
    let i = 0;
    const matCheckboxes = this.matCheckboxes.toArray();
    for (const stop of this.stopService.getNonCompletedStops.StopsList) {
      stop.IsSelected = $event.checked;
      matCheckboxes[i].checked = $event.checked;
      if ($event.checked) this.selectedStops.push(stop);
      else this.selectedStops = this.selectedStops.filter((e) => e !== stop);
      i++;
    }
  }

  updateCheckbox(event: any, Consol_ID: number) {
    let stop = this.stopService.getNonCompletedStops.StopsList.find(
      (x) => x.Consol_ID === Consol_ID
    );
    stop.IsSelected = event.checked;
    if (event.checked) this.selectedStops.push(stop);
    else this.selectedStops = this.selectedStops.filter((e) => e !== stop);
  }

  checkMultiple(event: MouseEvent, Consol_ID: number) {
    event.stopPropagation();
    let i = 0;
    const matCheckboxes = this.matCheckboxes.toArray();
    if (event.shiftKey) {
      let startSelecting = false;
      let stopLoop = false;
      let stop = this.stopService.getNonCompletedStops.StopsList.find(
        (x) => x.Consol_ID === Consol_ID
      );
      stop.IsSelected = true;
      for (const stop of this.stopService.getNonCompletedStops.StopsList) {
        if (stopLoop === false) {
          if (stop.IsSelected) {
            startSelecting = true;
          }
          if (stop.Consol_ID === Consol_ID) {
            startSelecting = false;
            stopLoop = true;
          }
          if (startSelecting) {
            let stop = this.stopService.getNonCompletedStops.StopsList.find(
              (x) => x.Consol_ID === stop.Consol_ID
            );
            stop.IsSelected = true;
            matCheckboxes[i].checked = true;
            this.selectedStops.push(stop);
          }
        }
        i++;
      }
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Stop): string {
    return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
  }

  search(): void {
    this.selectedStops = [];
    this.stopService.GetNonCompletedStops(this.selectedSectorId);
    setTimeout(() => {
      if (this.stopService.ncDataSource != undefined) {
        this.stopService.ncDataSource.sort = this.sort;
        const sortState: Sort = {active: 'EXP_DATE', direction: 'desc'};
        this.sort.active = sortState.active;
        this.sort.direction = sortState.direction;
        this.sort.sortChange.emit(sortState);
      }
    }, 2000);
  }

  public onClickAddException() {
    const dialogRef = this.dialog.open(AddExceptionDialogComponent, {
      height: '400px',
      width: '600px',
      data: {
        nonCompletedStops: this.selectedStops
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.search();
    });
  }

  getStatus(routeStatus: RouteStatus, stop: Stop): string {
    let _routeStatus = routeStatus.RouteStatus;
    const _minRouteStatus = stop.Min_Live_Route_Status;
    const _maxRouteStatus = stop.Max_Live_Route_Status;
    const Sectors: SectorCompress = this._sectorService.currentSectorValue;
    let _stopStatus: string = '000';
    let _cssclass: string = 'received';

    if (Sectors) {
      for (const oneroute of Sectors.RouteCompress) {
        if (oneroute.Route_ID === stop.Route_ID) {
          _routeStatus = String(oneroute.LiveRouteStatus);
          break;
        }
      }
    }

    _stopStatus = `0${String(_maxRouteStatus)}${String(_maxRouteStatus)}`;

    switch (_stopStatus) {
      case '000': {
        _cssclass = 'received';
        break;
      }
      case '001': {
        _cssclass = 'intransit';
        break;
      }
      case '011': {
        _cssclass = 'intransit';
        break;
      }
      case '111': {
        _cssclass = 'inroute';
        break;
      }
      case '022': {
        _cssclass = 'inroute';
        break;
      }
      case '033': {
        _cssclass = 'failed';
        break;
      }
      case '044': {
        _cssclass = 'shipped';
        break;
      }
      case '444': {
        _cssclass = 'shipped';
        break;
      }
      case '422': {
        _cssclass = 'inroute';
        break;
      }
      case '433': {
        _cssclass = 'failed';
        break;
      }
      default: {
        _cssclass = 'received';
        break;
      }
    }

    return _cssclass;
  }

  public GetParcelHistories(ParcelID: number) {
    this._parcelhistoryService.initialiseParcel(ParcelID);
    const dialogRef = this.dialog.open(ParcelHistoryDialogComponent, {
      height: '700px',
      width: '1400px',
      data: { parcelId: ParcelID }
    });
  }
  
  public getParcelStatusClass(parcelStatus: number): string {
    switch (parcelStatus) {
      case 1:
        return 'received';
      case 2:
        return 'scanned';
      case 3:
        return 'failed';
      case 4:
        return 'delivered';
      default:
        return 'received';
    }
  }

  sortParcels(ParcelCompress, prop: string) {
    const sorted = ParcelCompress.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
    // asc/desc
    if (prop.charAt(0) === '-') { sorted.reverse(); }
    return sorted;
}

}
